import React from 'react';

const SelectedFilters = ({ selectedFilter, closeButtonHandler }) => {
  return <div className="filter-select">
    <div>
      <span>Selected category: </span>
      <span className="selected-filter">
        {selectedFilter}
        <span className="icon-close" onClick={closeButtonHandler}></span>
      </span>
    </div>
  </div>
}

export default SelectedFilters;
